import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>

        <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-10">Last updated: {new Date().toLocaleDateString()}</p>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">1. Data We Collect</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            We collect account information you provide (name, email, phone number), authentication credentials,
            trading preferences, broker connection metadata (encrypted credentials, never plaintext), strategy
            configurations, trade history, and usage analytics required to operate the AutoTradePlug platform.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">2. How We Use It</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Your data is used to authenticate you, execute and monitor your trading strategies, display analytics,
            send transactional notifications, prevent fraud, and improve product reliability. We do not sell your
            personal data to third parties.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">3. Third Party Services</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            We rely on the following processors: Lovable Cloud (managed backend, database, authentication, file
            storage), Stripe (payment processing), and connected brokerage APIs you explicitly authorize. Each
            processor handles data under their own privacy and security commitments.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">4. Data Retention</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Account and trading data is retained while your account remains active. On account deletion request,
            personal data is removed within 30 days, except where retention is required by law (e.g. financial
            recordkeeping). Anonymized aggregates may be retained for analytics.
          </p>
        </section>

        <section className="space-y-3 mb-8">
          <h2 className="text-xl font-semibold">5. Contact</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            For privacy questions or data requests, contact <span className="font-medium">[YOUR COMPANY NAME]</span> at{' '}
            <span className="font-medium">[YOUR EMAIL]</span>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
